import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  return authService.getUser().then((user: any) => {
    // if no roles is refernced to a route, it is considered open for all type of roles
    if (route.data && route.data['roles']) {
      let hasAccess = route.data['roles'].some((role: string) => user.userRoles.includes(role));
      if (!hasAccess) {
        router.navigateByUrl('unauthorized');
      }
      return hasAccess
    } else {
      return true;
    }
  });
};
